module.exports = __webpack_public_path__ + "img/cloud-sunny.8d00fd30.svg";